import {
  IUsersResponse,
  IImpersonateResponse,
  IImpersonateRequest,
} from "../interfaces/impersonation";
import { fetchData } from "../utils/dataProvider";
import { GET, POST } from "../utils/constants";

export const getUsers = async (
  skip: number,
  count: number,
  search?: string,
): Promise<IUsersResponse> => {
  const response = await fetchData<IUsersResponse>({
    url: `/internal/users?limit=${count}&skip=${skip}${
      search ? `&search=${search}` : ""
    }`,
    method: GET,
  });
  return response;
};

export const impersonate = async (
  userId: number,
): Promise<IImpersonateResponse> => {
  const response = await fetchData<IImpersonateRequest>({
    url: "/internal/impersonate",
    method: POST,
    body: { userId },
  });
  return response;
};
